import { useRef, useEffect } from "react";
import { isEqual } from "lodash";

const useDeepCompare = (
  getResult: () => any,
  { defaultValue, required }: { defaultValue: any; required: boolean }
) => {
  const prevDefaultValue = useRef(defaultValue);
  const prevRequired = useRef(required);

  useEffect(() => {
    if (
      !isEqual(defaultValue, prevDefaultValue.current) ||
      !isEqual(required, prevRequired.current)
    ) {
      prevDefaultValue.current = defaultValue;
      prevRequired.current = required;
      getResult();
    }
  }, [defaultValue, required]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default useDeepCompare;
